import React, { Dispatch, SetStateAction } from 'react';
import { stepMap } from '@adac-mp/shared';
import { ChevronRight, ProductSummaryElement, Typography } from '../../index';
import { trackInteractionClick } from '../../utils/tracking/tracking';

interface IProdcutProcessRowProps {
	index: number;
	currStep: number;
	activeStep: number;
	supplier: number;
	label?: string;
	value?: React.ReactNode;
	scrollToStep: (step: number) => void;
	setActiveStep: Dispatch<SetStateAction<number>>;
}

export const ProductProcessRow = ({
	index,
	currStep,
	activeStep,
	label,
	value,
	supplier,
	scrollToStep,
	setActiveStep,
}: IProdcutProcessRowProps) => {
	const getIndicatorClasses = (elIndex: number, activeStepCount: number, currentStep: number) => {
		if (activeStepCount === elIndex) return 'bg-primary';
		return currentStep > elIndex ? 'border border-solid border-gray-500 bg-white' : 'bg-gray-700';
	};
	return (
		<div
			className={`flex items-baseline bg-white group ${
				currStep >= index + 1 ? 'cursor-pointer' : 'pointer-events-none'
			}`}
			role="button"
			tabIndex={currStep > index ? 0 : -1}
			onClick={() => {
				scrollToStep(index + 1);
				setActiveStep(index + 1);
				trackInteractionClick({
					label: `Auswahl ${value || stepMap[supplier][index + 1]}`,
					element: `${stepMap[supplier][currStep] || 'Product Done'} Konfiguration`,
				});
			}}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					scrollToStep(index + 1);
					setActiveStep(index + 1);
				}
			}}>
			<div className="relative top-2 flex items-baseline justify-center px-4 md:px-[44px]">
				<Typography
					className={`overflow-hidden rounded-half w-5 h-5 flex items-center justify-center relative z-[1] ${getIndicatorClasses(
						index + 1,
						activeStep,
						currStep,
					)}`}
					variant="title"
					color={`${currStep >= index + 1 ? 'title' : 'lightText'}`}
					size="lgEven">
					<span className="absolute w-full flex items-center justify-center transition-transform duration-200 group-hover:translate-x-full">
						{index + 1}
					</span>
					<span className="absolute w-full flex items-center justify-center transition-transform duration-200 -translate-x-full group-hover:translate-x-0">
						<ChevronRight />
					</span>
				</Typography>
			</div>
			<ProductSummaryElement
				notIndented
				wrap={index === 0} //wrap only for the first el, vignette name too long
				className={`flex-grow cursor-pointer ${index === 0 && 'border-t-0'}`}
				labelColor="lightText"
				label={label}
				value={value}
				id={''}
			/>
		</div>
	);
};
